import { Box, Button, Heading, HStack } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import Mainview from "./components/mainview";
import Layout from "./components/layout";

function App() {
  return (
    <Layout>
    <Mainview/>
      {/* <Box>
        <Heading mb={6}>Eclair</Heading>
        <HStack>
          <RouterLink to="/nfts">
            <Button as="span" colorScheme="blue">
              Explore
            </Button>
          </RouterLink>
          <RouterLink to="/mint">
            <Button as="span" colorScheme="blue">
              Create
            </Button>
          </RouterLink>
          <RouterLink to="/listings">
            <Button as="span" colorScheme="blue">
              Marketplace
            </Button>
          </RouterLink>
          <RouterLink to="/profile">
            <Button as="span" colorScheme="blue">
              Profile
            </Button>
          </RouterLink>
        </HStack>
      </Box> */}
    </Layout>
  );
}

export default App;
